import { useRef, type ReactNode } from 'react';
import { useFela } from 'react-fela';
import { CSSTransition } from 'react-transition-group';

import { Logo } from '@/modules/ui';

import { MenuButton } from '../MenuButton';
import { menuContent } from '../MenuDesktop/MenuDesktop.rules';
import * as felaRules from './MenuMobile.rules';

export interface MenuMobileProps {
    open: boolean;
    openMenu: () => void;
    closeMenu: () => void;
    onAnimationFinised: (open: boolean) => void;
    children: ReactNode;
}

export const MenuMobile = ({ open, openMenu, closeMenu, onAnimationFinised, children }: MenuMobileProps) => {
    const { css } = useFela();

    const nodeRef = useRef(null);

    return (
        <>
            <CSSTransition
                mountOnEnter
                unmountOnExit
                in={open}
                nodeRef={nodeRef}
                timeout={felaRules.TRANSITION_DURATION}
                onExited={() => {
                    onAnimationFinised(false);
                }}
                onEntered={() => {
                    onAnimationFinised(true);
                }}
            >
                <div ref={nodeRef} className={css(felaRules.menu)}>
                    <div className={css(felaRules.panelHeader)}>
                        <Logo />
                        <MenuButton type='close' handleClick={closeMenu} />
                    </div>
                    <div className={css(menuContent, felaRules.menuScroll)}>{children}</div>
                </div>
            </CSSTransition>
            {open && <div tabIndex={0} role='button' className={css(felaRules.menuOverlay)} onClick={closeMenu} />}
            <div className={css(felaRules.menuHeader)}>
                <MenuButton type='open' handleClick={openMenu} />
                <div className={css(felaRules.logoWrapper)}>
                    <Logo />
                </div>
            </div>
        </>
    );
};
